// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3wHJN","infoBtn":"quickbooks_infoBtn__3oijW","formBox":"quickbooks_formBox__2ZL82","formFooter":"quickbooks_formFooter__1-kBc"};